import { localization } from "../localizationManager";

export var frenchStrings = {
  groupButton: "Grouper",
  ungroupButton: "Dissocier",
  selectButton: "Sélectionner",
  hideColumn: "Masquer colonne",
  showColumn: "Afficher colonne",
  makePrivateColumn: "Rendre la colonne privé",
  makePublicColumn: "Rendre la colonne public",
  moveToDetail: "Déplacer vers détails",
  showAsColumn: "Afficher en colonne",
  visualizer_text: "Textes en table",
  visualizer_wordcloud: "Nuages de mots",
  chartType_bar: "Barres",
  chartType_stackedbar: "Barres empilées",
  chartType_doughnut: "Anneau",
  chartType_pie: "Secteurs",
  chartType_scatter: "Nuages de points",
  chartType_gauge: "Gauge",
  chartType_bullet: "Bulles",
  filter: "Filtre",
  hideButton: "Masquer",
  resetFilter: "Rafraichir Filtres",
  clearButton: "Rafraichir",
  addElement: "Choisir la question à afficher...",
  defaultOrder: "Defaut",
  ascOrder: "Ascendant",
  descOrder: "Descendant",
  showMinorColumns: "Afficher les colonnes mineures",
  otherCommentTitle: "Autre élément et commentaires",
  noVisualizerForQuestion: "Ce type de question n'est pas encore visualisé",
  noResults: "Il n'y a pas encore de résultats"
};

localization.locales["fr"] = frenchStrings;
localization.localeNames["fr"] = "French";